export const baseURL = `${window.location.origin}/v1/`;
// export const baseURL = `http://103.233.58.157:8080/v1`;
